// JavaScript Document

(function($) { 
  
    $(document).ready(function() {    
        theme.init()    
    });
    $(document).on("click touchstart", function(n) {
        var r = $(".quick-Shop");
        var i = $("#dropdown-cart");
        var s = $("#cartToggle");   
      
            if (!r.is(n.target) && r.has(n.target).length === 0 && !i.is(n.target) && i.has(n.target).length === 0 && !s.is(n.target) && s.has(n.target).length === 0 ) {
        	  theme.closeQuickBuyWindow();
              theme.closeDropdownCart();
          
        }
    });
   $(document).keyup(function(n) {
        if (n.keyCode == 27) {   
            theme.closeDropdownCart();
            clearTimeout(theme.themeTimeout);
            if ($(".modal").is(":visible")) {
                $(".modal").fadeOut(500)
            }
        }
    });
    var theme = {    
        themeTimeout: null,
        init: function() {  
           this.CallQuickBuy();
           this.CallModalScreen(); 
           this.CallWishlist();
           this.CallProductWishlist();
           this.CallProductMoreview();
           this.CallElevatezoom();
           this.CallAddToCart();
           this.CallProductAddToCart();
           this.CallDropDownCart();
         
        },
     
CallQuickBuy: function() {
            $(".quickShop-button a").click(function() {
                var n = $(this).attr("id");
                Shopify.getProduct(n, function(n) {
                    var r = $("#quickShop-template").html();
                    $(".quick-Shop").html(r);
                    var i = $(".quick-Shop");
                    var s = n.description.replace(/(<([^>]+)>)/ig, "");
                    s = s.split(" ").splice(0, 100).join(" ") + "...";
                    i.find(".product-title a").text(n.title);
                    i.find(".product-title a").attr("href", n.url);
                    if (i.find(".product-vendor span").length > 0) {
                        i.find(".product-vendor span").text(n.vendor)
                    }
                    if (i.find(".product-type span").length > 0) {
                        i.find(".product-type span").text(n.type)
                    }
                    if (i.find(".product-inventory span").length > 0) {
                        var o = n.variants[0].inventory_quantity;
                        if (o > 0) {
                            if (n.variants[0].inventory_management != null) {
                                i.find(".product-inventory span").text(o + " in stock")
                            } else {
                                i.find(".product-inventory span").text("Many in stock")
                            }
                        } else {
                            i.find(".product-inventory span").text("Out of stock")
                        }
                    }
                    i.find(".product-description").text(s);
                    i.find(".price").html(Shopify.formatMoney(n.price, window.money_format));
                    i.find(".product-item").attr("id", "product-" + n.id);
                    i.find(".variants").attr("id", "product-actions-" + n.id);
                    i.find(".variants select").attr("id", "product-select-" + n.id);
                    if (n.compare_at_price > n.price) {
                        i.find(".compare-price").html(Shopify.formatMoney(n.compare_at_price_max, window.money_format)).show();
                        i.find(".price").addClass("on-sale")
                    } else {
                        i.find(".compare-price").html("");
                        i.find(".price").removeClass("on-sale")
                    }
                    if (!n.available) {
                        i.find("select, input, .total-price, .dec, .inc, .variants label").remove();
                        i.find(".add-to-cart-btn").text("Unavailable").addClass("disabled").attr("disabled", "disabled");
                    } else {
                        i.find(".total-price span").html(Shopify.formatMoney(n.price, window.money_format));
                        theme.structureQuickBuyVariants(n, i)
                       
                       
                    }
                    i.find(".button").on("click", function() {
                        var n = i.find(".quantity").val(),
                            r = 1;
                        if ($(this).text() == "+") {
                            r = parseInt(n) + 1
                        } else if (n > 1) {
                            r = parseInt(n) - 1
                        }
                        i.find(".quantity").val(r);
                        if (i.find(".total-price").length > 0) {
                            theme.updatePricingquickShop()
                        }
                    });
                    if (window.show_multiple_currencies) {
                        Currency.convertAll(window.shop_currency, jQuery("#currencies").val(), "span.money", "money_format")
                    }
                    theme.CallQuickBuySlider(n, i);
                    theme.initquickShopAddToCart();
                    $(".quick-Shop").fadeIn(500);
                    if ($(".quick-Shop .total-price").length > 0) {
                        $(".quick-Shop input[name=quantity]").on("change", theme.updatePricingquickShop)
                    }
                });
                return false
            });
            $(".quick-Shop .overlay, .close-window").live("click", function() {
                theme.closeQuickBuyWindow();
                return false
           })
        },
      convertToSlug: function($) {
            return $.toLowerCase().replace(/[^\w ]+/g, "").replace(/ +/g, "-")
        },
     CallQuickBuySlider: function(n, r) {
           var s = Shopify.resizeImage(n.featured_image, "large");
            r.find(".quickShop-featured-image").append('<a href="' + n.url + '"><img src="' + s + '" title="' + n.title + '"/><div style="height: 100%; width: 100%; top:0; left:0 z-index: 2000; position: absolute; display: none; background: url(' + window.loading_url + ') 50% 50% no-repeat;"></div></a>');
            if (n.images.length > 1) {
                var o = r.find(".more-view-wrapper ul");
                for (i in n.images) {
                    var u = Shopify.resizeImage(n.images[i], "large");
                    var a = Shopify.resizeImage(n.images[i], "compact");
                    var f = '<li><a href="javascript:void(0)" data-image="' + u + '"><img src="' + a + '"  /></a></li>';
                    o.append(f)
                }
                o.find("a").click(function() {
                    var t = r.find(".quickShop-featured-image img");
                    var n = r.find(".quickShop-featured-image div");
                    if (t.attr("src") != $(this).attr("data-image")) {
                        t.attr("src", $(this).attr("data-image"));
                        n.show();
                        t.load(function(t) {
                            n.hide();
                            $(this).unbind("load");
                            n.hide()
                        })
                    }
                });
              if (o.hasClass("quickShop-more-views-owlslider")) {
                  theme.initquickShopCarousel(o);          
                }
                
                
            } else {
                r.find(".quickShop-more-views-owlslider").remove();
               
            }
        },
        initquickShopCarousel: function(e) {
            if (e) {
               e.owlCarousel({
                    navigation: true,
                    pagination:false,
                    items: 5,
                    itemsDesktop: [1199, 4],
                    itemsDesktopSmall: [979, 3],
                    itemsTablet: [768, 3],
                    itemsTabletSmall: [540, 3],
                    itemsMobile: [360, 3]
                })
            }
        },
      updatePricingquickShop: function() {
            var t = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
            var n = $(".quick-Shop .price").text().match(t);
            if (!n) {
                t = /([0-9]+[.|,][0-9]+)/g;
                n = $(".quick-Shop .price").text().match(t)
            }
            if (n) {
                var r = n[0];
                var i = r.replace(/[.|,]/g, "");
                var s = parseInt($(".quick-Shop input[name=quantity]").val());
                var o = i * s;
                var u = Shopify.formatMoney(o, window.money_format);
                u = u.match(t)[0];
                var a = new RegExp(r, "g");
                var f = $(".quick-Shop .price").html().replace(a, u);
                $(".quick-Shop .total-price span").html(f)
            }
        },
       initquickShopAddToCart: function() {
            if ($(".quick-Shop .add-to-cart-btn").length > 0) {
                $(".quick-Shop .add-to-cart-btn").click(function() {
                    var n = $(".quick-Shop select[name=id]").val();
                    if (!n) {
                        n = $(".quick-Shop input[name=id]").val()
                    }
                    var r = $(".quick-Shop input[name=quantity]").val();
                    if (!r) {
                        r = 1
                    }
                    var i = $(".quick-Shop .product-title a").text();
                    var s = $(".quick-Shop .quickShop-featured-image img").attr("src");
                    theme.doAjaxAddToCart(n, r, i, s);
                    theme.closeQuickBuyWindow()
                })
            }
        },
       structureQuickBuyVariants: function(theme, n) {           
            if (theme.variants.length > 1) {
                for (var r = 0; r < theme.variants.length; r++) {
                    var i = theme.variants[r];
                    var s = '<option value="' + i.id + '">' + i.title + "</option>";
                    n.find("form.variants > select").append(s)
                }
                new Shopify.OptionSelectors("product-select-" + theme.id, {
                    product: theme,
                    onVariantSelected: selectCallbackquickShop
                });
                $(".quick-Shop .single-option-selector").selectize();
                $(".quick-Shop .selectize-input input").attr("disabled", "disabled");
                if (theme.options.length == 1) {
                    $(".selector-wrapper:eq(0)").prepend("<label>" + theme.options[0].name + "</label>")
                }
                n.find("form.variants .selector-wrapper label").each(function(n, r) {
                    $(this).html(theme.options[n].name)
                })
            } else {
                n.find("form.variants > select").remove();
                var o = '<input type="hidden" name="id" value="' + theme.variants[0].id + '">';
                n.find("form.variants").append(o)
            }
        },
        closeQuickBuyWindow: function() { 
            $(".quick-Shop").fadeOut(500)
        },
    
      CallWishlist: function() {
            $(".wishlist-login").click(function(n) {
                n.preventDefault();
              var r = $(this).parent();              
              var i = r.parents(".productCycle"); 
                $.ajax({
                    type: "POST",
                    url: "/contact",
                    data: r.serialize(),
                    beforeSend: function() {
                        theme.showLoading()
                    },
                    success: function(n) {
                        theme.hideLoading();
                        r.html('<a href="/pages/wish-list" class="product-wishlist" title="Browse wishlist"><i class="fa fa-heart-o"></i></a>');
                        var s = i.find(".productName").text();  
                      console.log(s);
                        var o = i.find("#productPhotoImg").attr("src");
                       console.log(o);
                        $(".ajax-success-modal").find(".ajax-productName").text(s);
                        $(".ajax-success-modal").find(".ajax-product-image").attr("src", o);
                        $(".ajax-success-modal").find(".go-to-wishlist").show();
                        $(".ajax-success-modal").find(".go-to-cart").hide();
                        theme.showModal(".ajax-success-modal")
                    },
                    error: function(n, r) {
                        theme.hideLoading();
                        $(".loading-modal").hide();
                        $(".ajax-error-message").text($.parseJSON(n.responseText).description);
                        theme.showModal(".ajax-error-modal")
                    }
                })
            })
        },
        CallProductWishlist: function() {
            $(".product-detail-section .wishlist-button").click(function(n) {
                n.preventDefault();
                var r = $(this).parent();
               console.log(r);
                var i = r.parents(".product-row");
              console.log(i);
                $.ajax({
                    type: "POST",
                    url: "/contact",
                    data: r.serialize(),
                    beforeSend: function() {
                        theme.showLoading()
                    },
                    success: function(n) {
                        theme.hideLoading();
                        r.html('<a href="/pages/wish-list" class="product-wishlist" title="Browse wishlist"><i class="fa fa-heart-o"></i><span>Go to wishlist</span></a>');
                        var i = $(".product-title").text();
                        var s = $("#productFeaturedImg").attr("src");
                        $(".ajax-success-modal").find(".ajax-productName").text(i);
                        $(".ajax-success-modal").find(".ajax-product-image").attr("src", s);
                        $(".ajax-success-modal").find(".go-to-wishlist").show();
                      	$(".ajax-success-modal").find(".go-to-cart").hide();
                        theme.showModal(".ajax-success-modal")
                    },
                    error: function(n, r) {
                        theme.hideLoading();
                        $(".loading-modal").hide();
                        $(".ajax-error-message").text($.parseJSON(n.responseText).description);
                        theme.showModal(".ajax-error-modal")
                    }
                })
            })
        },
      
        CallProductMoreview: function(t) {
          if ($(".show-jcarousel-view").length > 0) {
            
                $(".show-jcarousel-view ul").jcarousel({ vertical: true }).css("visibility", "visible");
                $(".product-image").addClass("contain-jcarousel");
                $(".carousel-wrapper").css("visibility", "visible")
             }
        },
      
      CallElevatezoom: function() {
      if ($("#productFeaturedImg").length > 0) {               
                    $("#productFeaturedImg").elevateZoom({
                        gallery: "productPhotoThumb",
                        cursor: "crosshair",
                        //zoomType: "inner",
                        galleryActiveClass: "active",
                        imageCrossfade: true,
                        lensSize: 200,
                        scrollZoom: true,
                        onImageSwapComplete: function() {
                            $(".zoomWrapper div").hide()
                        },
                        loadingIcon: window.loading_url
                    });
                    $("#productFeaturedImg").bind("click", function() {
                        var n = $("#productFeaturedImg").data("elevateZoom");
                        $.fancybox(n.getGalleryList());
                        return false
                    })
            }
            
      },
       CallModalScreen: function() {
            $(".continue-shopping").click(function() {
                clearTimeout(theme.themeTimeout);
                $(".ajax-success-modal").fadeOut(500)
            });
            $(".close-modal, .overlay").click(function() {
                clearTimeout(theme.themeTimeout);
                $(".ajax-success-modal").fadeOut(500)
            })
        },
      showModal: function(n) {
            $(n).fadeIn(500);
            theme.themeTimeout = setTimeout(function() {
                $(n).fadeOut(500)
            }, 5e3)
        },
       showLoading: function() {
            $(".loading-modal").show()
        },
        hideLoading: function() {
            $(".loading-modal").hide()
        },
      CallProductAddToCart: function() {
            if ($("#product-add-to-cart").length > 0) {
                $("#product-add-to-cart").click(function(n) {
                    n.preventDefault();
                    if ($(this).attr("disabled") != "disabled") {
                        if (!window.ajax_cart) {
                            $(this).closest("form").submit()
                        } else {
                            var r = $("#add-to-cart-form select[name=id]").val();
                            if (!r) {
                                r = $("#add-to-cart-form input[name=id]").val()
                            }
                            var i = $("#add-to-cart-form input[name=quantity]").val();
                            if (!i) {
                                i = 1
                            }
                            var s = $(".product-title").text();
                            var o = $("#productFeaturedImg").attr("src");
                            theme.doAjaxAddToCart(r, i, s, o)
                        }
                    }
                    return false
                })
            }
        },
        CallAddToCart: function() {
            if ($(".add-to-cart-btn").length > 0) {
                $(".add-to-cart-btn").click(function(n) {
                    n.preventDefault();
                    if ($(this).attr("disabled") != "disabled") {
                        var r = $(this).parents(".productCycle");
                        var i = $(r).attr("id");
                        i = i.match(/\d+/g);
                        if (!window.ajax_cart) {
                            $("#addToCartForm-" + i).submit()
                        } else {
                            var s = $("#addToCartForm-" + i + " select[name=id]").val();
                          if (!s) {
                                s = $("#addToCartForm-" + i + " input[name=id]").val()
                            }
                            var o = $("#addToCartForm-" + i + " input[name=quantity]").val();
                            if (!o) {
                                o = 1
                            }
                         
                            var u = $(r).find(".productName").text();
                            var a = $(r).find("#productPhotoImg").attr("src");
                          
                            theme.doAjaxAddToCart(s, o, u, a)
                        }
                    }
                    return false
                })
            }
        },
       
        doAjaxAddToCart: function(n, r, i, s) {
            $.ajax({
                type: "post",
                url: "/cart/add.js",
                data: "quantity=" + r + "&id=" + n,
                dataType: "json",
                beforeSend: function() {
                    theme.showLoading()
                },
                success: function(n) {
                    theme.hideLoading();
					$(".ajax-success-modal").find(".ajax-productName").text(i);
                    $(".ajax-success-modal").find(".ajax-product-image").attr("src", s);
                    $(".ajax-success-modal").find(".go-to-wishlist").hide();
                    $(".ajax-success-modal").find(".go-to-cart").show();
                    theme.showModal(".ajax-success-modal");
                    theme.updateDropdownCart()
                },
                error: function(n, r) {
                    theme.hideLoading();
                    $(".ajax-error-message").text($.parseJSON(n.responseText).description);
                    theme.showModal(".ajax-error-modal")
                }
            })
        },
      updateDropdownCart: function() {
            Shopify.getCart(function(e) {
                theme.doUpdateDropdownCart(e)
            })
        },
        doUpdateDropdownCart: function(n) {
            var r = '<li class="item" id="cart-item-{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a href="javascript:void(0)" title="Remove This Item" class="trash btn-remove"><i class="fa fa-trash-o pull-left"></i></a><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="cart-collateral">{QUANTITY} x <span class="price">{PRICE}</span></div></div></li>';
            $("#cartCount").text("("+n.item_count+")");
            $("#dropdown-cart .summary .price").html(Shopify.formatMoney(n.total_price, window.money_format));
            $("#dropdown-cart .mini-products-list").html("");
            if (n.item_count > 0) {
                for (var i = 0; i < n.items.length; i++) {
                    var s = r;
                    s = s.replace(/\{ID\}/g, n.items[i].id);
                    s = s.replace(/\{URL\}/g, n.items[i].url);
                    s = s.replace(/\{TITLE\}/g, n.items[i].title);
                    s = s.replace(/\{QUANTITY\}/g, n.items[i].quantity);
                    s = s.replace(/\{IMAGE\}/g, Shopify.resizeImage(n.items[i].image, "small"));
                    s = s.replace(/\{PRICE\}/g, Shopify.formatMoney(n.items[i].price, window.money_format));
                    $("#dropdown-cart .mini-products-list").append(s)
                }
                $("#dropdown-cart .btn-remove").click(function(n) {
                    n.preventDefault();
                    var r = $(this).parents(".item").attr("id");
                    r = r.match(/\d+/g);
                    Shopify.removeItem(r, function(e) {
                        theme.doUpdateDropdownCart(e)
                    })
                });
                if (theme.checkNeedToConvertCurrency()) {
                    Currency.convertAll(window.shop_currency, jQuery("#currencies").val(), "#dropdown-cart span.money", "money_format")
                }
            }
            theme.checkItemsInDropdownCart()
        },
        checkNeedToConvertCurrency: function() {
            return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency
        },
    CallDropDownCart: function() {
            if (window.dropdowncart_type == "click") {
                $("#cartToggle").click(function() {
                    if ($("#dropdown-cart").is(":visible")) {
                        $("#dropdown-cart").slideUp("fast")
                    } else {
                        $("#dropdown-cart").slideDown("fast")
                    }
                })
            } else {
                if (!("ontouchstart" in document)) {
                    $("#cartToggle").hover(function() {
                        if (!$("#dropdown-cart").is(":visible")) {
                            $("#dropdown-cart").slideDown("fast")
                        }
                    });
                    $(".wrapper-top-cart").mouseleave(function() {
                        $("#dropdown-cart").slideUp("fast")
                    })
                } else {
                    $("#cartToggle").click(function() {
                        if ($("#dropdown-cart").is(":visible")) {
                            $("#dropdown-cart").slideUp("fast")
                        } else {
                            $("#dropdown-cart").slideDown("fast")
                        }
                    })
                }
            }
            theme.checkItemsInDropdownCart();
            $("#dropdown-cart .no-items a").click(function() {
                $("#dropdown-cart").slideUp("fast")
            });
            $("#dropdown-cart .btn-remove").click(function(n) {
                n.preventDefault();
                var r = $(this).parents(".item").attr("id");
                r = r.match(/\d+/g);
                Shopify.removeItem(r, function(e) {
                    theme.doUpdateDropdownCart(e)
                })
            })
        },
       checkItemsInDropdownCart: function() {
            if ($("#dropdown-cart .mini-products-list").children().length > 0) {
                $("#dropdown-cart .no-items").hide();
                $("#dropdown-cart .has-items").show()
            } else {
                $("#dropdown-cart .has-items").hide();
                $("#dropdown-cart .no-items").show()
            }
        },
       closeDropdownCart: function() {
            if ($("#dropdown-cart").is(":visible")) {
                $("#dropdown-cart").slideUp("fast")
            }
        }
      
     
    }
})(jQuery)

